export class QuestionViewModel {
  public id?: string;
  public text?: string;
  public additionalInstructions?: string;
  public answerType?: string;
  public origAnswerText?: string;
  public paraAnswerText?: string;
  public wasParaEdited: boolean;
  public _isParaEditing: boolean;

  constructor (text?: string, additionalInstructions?: string, answerType?: string, id?: string) {
    this.id = id
    this.text = text
    this.additionalInstructions = additionalInstructions
    this.answerType = answerType
    this.wasParaEdited = false
    this._isParaEditing = false
  }
}
